<template>
    <component v-bind:is="componentName"></component>
</template>

<script>
import DashboardLayout from '../main-column/DashboardLayout.vue';
import FuelUtilizationLayout from '../main-column/FuelUtilizationLayout.vue';
import PurchaseActivityLayout from '../main-column/PurchaseActivityLayout.vue';
import AllergyKpisLayout from '../main-column/AllergyKpisLayout.vue';
import AudiologyKpisLayout from '../main-column/AudiologyKpisLayout.vue';
import FuelFundsLayout from '../main-column/FuelFundsLayout.vue';
import DigitalPromoLayout from '../main-column/DigitalPromoLayout.vue';
import ProfessionalDevelopmentLayout from '../main-column/ProfessionalDevelopmentLayout.vue';
import LibraryLayout from '../main-column/LibraryLayout.vue';
import BatteryStoreLayout from '../main-column/BatteryStoreLayout.vue';
import PayInvoiceLayout from '../main-column/PayInvoiceLayout.vue';
import PricingGuidesLayout from '../main-column/PricingGuidesLayout.vue';
import MeetingAgendasLayout from '../main-column/MeetingAgendasLayout.vue';
import MeetingAgendaLayout from '../main-column/MeetingAgendaLayout.vue';
import VendorPartnersLayout from '../main-column/VendorPartnersLayout.vue';

export default {
name: 'MainColumn',
  props: {
    componentName: {
      type: String,
      required: true,
    },
  },
  components: {
      DashboardLayout,
      FuelUtilizationLayout,
      PurchaseActivityLayout,
      AllergyKpisLayout,
      AudiologyKpisLayout,
      FuelFundsLayout,
      DigitalPromoLayout,
      ProfessionalDevelopmentLayout,
      LibraryLayout,
      BatteryStoreLayout,
      PayInvoiceLayout,
      PricingGuidesLayout,
      MeetingAgendasLayout,
      MeetingAgendaLayout,
      VendorPartnersLayout,
  },
};
</script>
